import { useQuery } from 'react-query';
import { model as phenotypeModel, Phenotype } from './phenotype';

export const phenotypesQueryKey = (phenotypeId: number) => ['phenotype', {phenotypeId}];

export const useGetPhenotype = (phenotypeId: number) =>
  useQuery<Phenotype>(phenotypesQueryKey(phenotypeId), () =>
    phenotypeModel().getPhenotype(phenotypeId),
  );
